import addToCart from './addToCart';
import updateQuantity from './updateQuantity';
import cartEditItem from './cartEditItem';
import { plusQuantity, minusQuantity } from './plusMinusQuantity';
import interactionBlocker from './interactionBlocker';
// import themeEditor from './themeEditor';
import AddToBag from '../../components/CartATB';
import CartShipping from './cartShipping';
import PromoCode, { StickyCheckout } from './cartTotals';
import PriceBreakdownButtonn from './cartPriceBreakdownButton';
import share from './share';
import finalSale from './finalSale';
// import { Children } from 'react';

export default () => {
  // Initialize Add to Bag Popover Component whenever not on cart page
  if (window.location.pathname !== '/cart') {
    customElements.define('add-to-bag', AddToBag);
  }

  // Initialize Final Sale Calculation
  finalSale();

  // Initiliaze Cart Shipping
  customElements.define('free-shipping-bar', CartShipping);

  // Initialize Cart Promo Code
  customElements.define('promo-code', PromoCode);

  // Initialize Price Breakdown Button. It will address to customer to price breakdown section
  customElements.define('price-breakdown-button', PriceBreakdownButtonn);

  // Initialize Sticky Checkout for mobile experience
  customElements.define('sticky-checkout', StickyCheckout);

  // Only call if not already initialized
  if (!document.querySelector('#share-overlay[data-initialized]')) {
    share();
    document.querySelector('#share-overlay')?.setAttribute('data-initialized', 'true');
  }

  document.querySelectorAll('[data-cart-back]').forEach(function (element) {
    element.addEventListener('click', function () {
      window.history.back();
    });
  });

  document.addEventListener('submit', function (e) {
    // Add to cart form hijacking...this is where the magic happens
    if (e.target.matches('form[action^="/cart/add"]')) {
      e.preventDefault();
      const cartButton = e.target.querySelector('button[type="submit"]');
      if (cartButton && cartButton.dataset.waitlistOpen === 'true') return;
      // Interaction blockers: block interaction with cart
      interactionBlocker(true);
      // Switches the add to cart form to edit cart item form
      if (e.target.matches('form[data-edit-cart-item="true"]')) {
        return cartEditItem(e.target);
      }
      addToCart(e.target);
    }
  });

  document.addEventListener('click', function (e) {
    if (e.target.matches('.Cart .CartTotals__promo-code .btn-submit')) {
      let cartHasGiftCard = false;
      if (window.cart && window.cart.items) {
        cartHasGiftCard = window.cart.items.some((item) => item.product_type.includes('GIVEX'));
        if (cartHasGiftCard) {
          const errorMessageGC = document.querySelector('.promo-error-gc');
          errorMessageGC.style.display = 'block';
          setTimeout(function () {
            errorMessageGC.style.display = 'none';
          }, 10000);
          return;
        }
      }

      e.preventDefault();
      const inputElement = e.target.previousElementSibling;
      const value = inputElement.value.toString().trim();
      const country_selected = document.querySelector('[data-country-selected]');
      const country_iso_selected = country_selected.getAttribute('data-country-selected');
      const card_number = value;
      if (value !== '') {
        if (card_number.indexOf('609074') !== 0) {
          window.location.href = `/discount/${value}?redirect=/cart`;
        } else {
          const domain = window.location.host;
          const url =
            domain === 'www.windsorstore.com'
              ? 'https://gift-card-service.wndsr.io/find'
              : 'https://gift-card-service.wndsr.dev/find';

          // Interaction blockers: block interaction with cart
          interactionBlocker(true);

          fetch(url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              givex_number: card_number,
              security_code: prompt('Please enter your card PIN'),
            }),
          })
            .then((response) => {
              if (!response.ok) {
                throw new Error('Invalid gift card number or PIN.');
              }
              return response.json();
            })
            .then(() => {
              window.location.href = `/checkout?discount=${value}&country=${country_iso_selected}`;
            })
            .catch((error) => {
              // Interaction blockers: unblock cart
              interactionBlocker();
              alert(error.message);
            });
        }
      }
      return false;
    }
  });

  // Need this again without the dynamic selector to keep Shopify frmo double firing pixels...sigh
  document.querySelectorAll('form[action^="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
    });
  });

  // Remove button
  document.querySelector('[data-cart]').addEventListener('click', function (e) {
    if (e.target.matches('[data-cart-remove]')) {
      const cartProduct = e.target.closest('.CartProduct');
      const itemId = cartProduct.dataset.id;

      // Interaction blockers: block interaction with cart
      interactionBlocker(true);
      updateQuantity(0, itemId);
    }
  });

  // Change quantity
  document.querySelector('[data-cart]').addEventListener('change', function (e) {
    e.preventDefault();
    if (e.target.matches('[name="quantity"]')) {
      const cartProduct = e.target.closest('.CartProduct');
      const value = e.target.value;
      const itemId = cartProduct.dataset.id;

      // Interaction blockers: block interaction with cart
      interactionBlocker(true);
      updateQuantity(value, itemId);
    }
  });

  document.addEventListener('click', function (e) {
    if (e.target.matches('[data-quantity-plus]')) {
      plusQuantity(e);
    } else if (e.target.matches('[data-quantity-minus]')) {
      minusQuantity(e);
    }
  });
};
